import styled from 'styled-components';

export const StyledRadio = styled('input')`
  width: 16px;
  height: 16px;
  accent-color: #262ba6;
`;

export const StyledRadioLabel = styled('label')`
  font-size: 13px;
  font-weight: 400;
  line-height: 15.6px;
  text-align: left;
  color: #4d4d4d;
`;

export const Wrapper = styled('div')`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  gap: 8px;
`;
